import { createTypes, createAction } from "lib/action";

const LOAD_CUSTOMERS = createTypes("loadCustomers", "load");
const LOAD_CONTACTS = createTypes("loadContacts", "load");
const LOAD_LINE_USERS = createTypes("loadLineUsers", "load");
const LOAD_VERIFIED_USERS = createTypes("loadVerifiedUsers", "load");
const EXPORT_CUSTOMERS = createTypes("exportCustomers", "export");
const EXPORT_CONTACTS = createTypes("exportContacts", "export");
const EXPORT_VERIFIED_USERS = createTypes("exportVerifiedUsers", "export");

const loadCustomers = {
  request: (params, token) => createAction(LOAD_CUSTOMERS.REQUEST, { params, token }),
  success: data => createAction(LOAD_CUSTOMERS.SUCCESS, { data }),
  failure: err => createAction(LOAD_CUSTOMERS.FAILURE, { err }),
};

const loadContacts = {
  request: (params, token) => createAction(LOAD_CONTACTS.REQUEST, { params, token }),
  success: data => createAction(LOAD_CONTACTS.SUCCESS, { data }),
  failure: err => createAction(LOAD_CONTACTS.FAILURE, { err }),
};

const loadLineUsers = {
  request: (params, token) => createAction(LOAD_LINE_USERS.REQUEST, { params, token }),
  success: data => createAction(LOAD_LINE_USERS.SUCCESS, { data }),
  failure: err => createAction(LOAD_LINE_USERS.FAILURE, { err }),
};

const loadVerifiedUsers = {
  request: (params, token) => createAction(LOAD_VERIFIED_USERS.REQUEST, { params, token }),
  success: data => createAction(LOAD_VERIFIED_USERS.SUCCESS, { data }),
  failure: err => createAction(LOAD_VERIFIED_USERS.FAILURE, { err }),
};

const exportCustomers = {
  request: (token) => createAction(EXPORT_CUSTOMERS.REQUEST, { token }),
  success: data => createAction(EXPORT_CUSTOMERS.SUCCESS, { data }),
  failure: err => createAction(EXPORT_CUSTOMERS.FAILURE, { err }),
};

const exportContacts = {
  request: (token) => createAction(EXPORT_CONTACTS.REQUEST, { token }),
  success: data => createAction(EXPORT_CONTACTS.SUCCESS, { data }),
  failure: err => createAction(EXPORT_CONTACTS.FAILURE, { err }),
};

const exportVerifiedUsers = {
  request: (token) => createAction(EXPORT_VERIFIED_USERS.REQUEST, { token }),
  success: data => createAction(EXPORT_VERIFIED_USERS.SUCCESS, { data }),
  failure: err => createAction(EXPORT_VERIFIED_USERS.FAILURE, { err }),
};

export {
  loadCustomers,
  LOAD_CUSTOMERS,
  loadContacts,
  LOAD_CONTACTS,
  loadLineUsers,
  LOAD_LINE_USERS,
  loadVerifiedUsers,
  LOAD_VERIFIED_USERS,
  exportCustomers,
  EXPORT_CUSTOMERS,
  exportContacts,
  EXPORT_CONTACTS,
  exportVerifiedUsers,
  EXPORT_VERIFIED_USERS,
};

